import { Layout } from '../layouts/Layout';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import EmployeeForm from '../components/EmployeeForm';

/**
 * EmployeeCreate page component
 * Displays the employee creation form wrapped in the application layout
 */
export default function EmployeeCreate() {
  return (
    <Layout>
      <Sidebar />
      <div className="md:ml-64">
        <Header />
        <main className="p-6">
          <EmployeeForm mode="create" />
        </main>
      </div>
    </Layout>
  );
}
